import React, { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';

const ScrollButton = styled('button')(({ theme, visible }) => ({
  position: 'fixed',
  bottom: '2rem',
  right: '2rem',
  width: '56px',
  height: '56px',
  borderRadius: '50%',
  background: 'linear-gradient(135deg, #0c5470 0%, #428bca 100%)',
  border: 'none',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxShadow: '0 8px 25px rgba(0, 0, 0, 0.15)',
  transition: 'all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
  zIndex: 1000,
  opacity: visible ? 1 : 0,
  transform: visible ? 'translateY(0) scale(1)' : 'translateY(100px) scale(0.8)',
  pointerEvents: visible ? 'auto' : 'none',
  
  '&:hover': {
    transform: visible ? 'translateY(-5px) scale(1.1)' : 'translateY(100px) scale(0.8)',
    boxShadow: '0 15px 35px rgba(0, 0, 0, 0.2)',
    background: 'linear-gradient(135deg, #428bca 0%, #20c997 100%)',
  },
  
  '&:active': {
    transform: visible ? 'translateY(-2px) scale(1.05)' : 'translateY(100px) scale(0.8)',
  },
  
  '& svg': {
    width: '24px',
    height: '24px',
    fill: 'white',
    transition: 'transform 0.2s ease-in-out',
  },
  
  '&:hover svg': {
    transform: 'translateY(-2px)',
  },
  
  '@media screen and (max-width: 768px)': {
    bottom: '1.5rem',
    right: '1.5rem',
    width: '48px',
    height: '48px',
    
    '& svg': {
      width: '20px',
      height: '20px',
    },
  },
}));

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility, { passive: true });
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <ScrollButton
      visible={isVisible}
      onClick={scrollToTop}
      aria-label="Scroll naar top"
    >
      <svg viewBox="0 0 24 24">
        <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"/>
      </svg>
    </ScrollButton>
  );
};

export default ScrollToTopButton;